// Re:Vault - brand constants. Single source for the name, logo, and copy so
// every surface (app, settings, folders, errors, policy pages) stays consistent.

import { MARK_INLINE } from "./brand-mark.js";

export const NAME = "Re:Vault";
export const TAGLINE = "Your study space, all in one place.";
export const DESCRIPTION =
	"Re:Vault is a fast, private study browser built for Chromebooks - a distraction-free learning workspace with a built-in library, study tools, worksheets, and a clean tabbed reader for research and classwork.";

// Vee, the face-only mark (the kit's favicon cut, the one drawn for 16-48px). Generated from
// brand/vee/ by tools/brand-mark.mjs, like every other copy of the mark.
export const LOGO_SVG = MARK_INLINE;

// Inject the logo into an element by id (used by app + settings entries).
export function mountLogo(el) {
	if (el) el.innerHTML = LOGO_SVG;
}
